<template>
  <article class="PageArticle">
    <h3 class="PageArticle_title" v-html="data.title" v-if="data.title"></h3>
    <div class="PageArticle_content" v-html="data.content" v-if="data.content"></div>
    <img class="PageArticle_image" :src="data.image" v-if="data.image"/>
  </article>
</template>

<script>
  import scrollUpdate from '@/mixins/scrollUpdate'

  export default {
    name: "PageArticle",
    props: [ 'data', 'index' ],
    mixins: [ scrollUpdate ],
    methods: {
      onProgress(p, pv)
      {
        if(pv > 0.2 && p <= 0.8)
        {
          this.$emit('navRefresh', window.location.pathname + '#Article' + this.index)
        }
      }
    },
    mounted()
    {
      this.$scroll.set(this.$el, { y: 0, opacity: 1 }, { y: 60, opacity: 0.5 }, { y: 0, opacity: 1 }, null, 0.65)
    }
  }
</script>

<style lang="stylus" scoped>
.PageArticle

  position relative
  max-width 690px
  width 100%
  border-bottom 1px solid $n2
  padding 0px 0px 60px 0px
  margin-top 60px
  text-align left

  @media $small

    padding-bottom 20px

  img

    width 100%
    display block
    margin-top 60px

    @media $small

      margin-top 30px
</style>